import { useTinyHost } from "@tiny/host-contract";
import React from "react";
import classNames from "classnames";

import { InfoTooltip, Typography, Link } from "..";
import CircleChevronRight from "@tiny/icons/generated/CircleChevronRight";

import { StatisticsProps } from "./Statistics.types";
import { useStyles } from "./Statistics.styles";
import useId from "../hooks/useId";

function Statistics(props: StatisticsProps) {
  const { navigate } = useTinyHost();
  const { title, value, valueVariant = "h2", info, link, bullet } = props;

  const classes = useStyles(props);

  const rootClassName = classNames(classes.root, {
    [classes.rootBullet]: bullet,
  });

  const valueClassName = classNames(classes.value, {
    [classes.valueBullet]: bullet,
  });

  const titleId = useId();

  return (
    <div className={rootClassName}>
      <Typography
        className={valueClassName}
        variant={valueVariant}
        component="strong"
        fontWeight="semiBold"
        aria-labelledby={titleId}
        color="grey"
        tone={900}
        display="block"
        mb={1}
      >
        {value === undefined ? "-" : value}
      </Typography>
      <div className={classes.content}>
        {link ? (
          <Typography
            variant="label2"
            component="div"
            color="primary"
            tone="main"
          >
            <Link
              onClick={() => navigate.to(String(link))}
              icon={<CircleChevronRight />}
              component={"button" as React.ElementType}
              iconClassName={classes.icon}
            >
              {title}
            </Link>
          </Typography>
        ) : (
          <>
            <Typography
              variant="label2"
              color="grey"
              tone={700}
              component="div"
              id={titleId}
            >
              {title}
            </Typography>
            {info && (
              <InfoTooltip
                className={classes.tooltip}
                title={info}
                size="tiny"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Statistics;
